export default "__VITE_ASSET__5ST6Qrfq__"